var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import IconInformation from './Icons/IconInformation.vue';
let ErrorBanner = class ErrorBanner extends Vue {
};
__decorate([
    Prop({ default: '#fdeae6' })
], ErrorBanner.prototype, "bgColor", void 0);
ErrorBanner = __decorate([
    Component({
        components: {
            IconInformation,
        },
    })
], ErrorBanner);
export default ErrorBanner;
